import { IOptionSettings } from './types';

export const MINUTE_IN_MS = 60000;

export const HOUR_IN_MINUTES = 60;

export const HOUR_IN_MS = MINUTE_IN_MS * HOUR_IN_MINUTES;

export const OPTION_NOW: IOptionSettings = {
  id: 'now',
  inMinutes: 0,
  inSeconds: 0,
  labelId: 'now',
  ariaLabel: { id: 'prepareNowLabel' },
};

export const OPTION_FIVE_MIN: IOptionSettings = {
  id: '5min',
  inMinutes: 5,
  inSeconds: 300,
  labelId: 'fiveMin',
  ariaLabel: { id: 'prepareIn5MinLabel' },
};

export const OPTION_TEN_MIN: IOptionSettings = {
  id: '10min',
  inMinutes: 10,
  inSeconds: 600,
  labelId: 'tenMin',
  ariaLabel: { id: 'prepareIn10MinLabel' },
};

export const OPTION_FIFTEEN_MIN: IOptionSettings = {
  id: '15min',
  inMinutes: 15,
  inSeconds: 900,
  labelId: 'fifteenMin',
  ariaLabel: { id: 'prepareIn15MinLabel' },
};

export const OPTION_TWENTY_MIN: IOptionSettings = {
  id: '20min',
  inMinutes: 20,
  inSeconds: 1200,
  labelId: 'twentyMin',
  ariaLabel: { id: 'prepareIn20MinLabel' },
};

export const OPTION_THIRTY_MIN: IOptionSettings = {
  id: '30min',
  inMinutes: 30,
  inSeconds: 1800,
  labelId: 'thirtyMin',
  ariaLabel: { id: 'prepareIn30MinLabel' },
};

export const OPTION_FOURTY_FIVE_MIN: IOptionSettings = {
  id: '45min',
  inMinutes: 45,
  inSeconds: 2700,
  labelId: 'fourtyFiveMin',
  ariaLabel: { id: 'prepareIn45MinLabel' },
};

export const OPTION_SIXTY_MIN: IOptionSettings = {
  id: '60min',
  inMinutes: 60,
  inSeconds: 3600,
  labelId: 'sixtyMin',
  ariaLabel: { id: 'prepareIn60MinLabel' },
};
